let collectedStyles = "";

const collectStyles = style => collectedStyles += style;

const getStyles = () => collectedStyles;

export { collectStyles, getStyles };
